define('responsive-gameday/views/distributors/viewDistributors/MatchupDistributor',['require','exports','module','GameDayCore','./ViewDistributorBase','../../Monitor/Events/ViewModelUpdateEvents','message-service/message-service','../events/DistributionEvents','extant/extant','gameday-resource-path/gameday-resource-path','GameDayCore/GDModel/enums/baseball/GameStates'],function(require,exports,module) {
	var GDC = require("GameDayCore"),
		ViewDistributorClass = require("./ViewDistributorBase"),
		UpdateEvents = require("../../Monitor/Events/ViewModelUpdateEvents"),
		MessageService = require("message-service/message-service"),
		DistEvents = require("../events/DistributionEvents"),
		exists = require("extant/extant"),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
		GameStates = require("GameDayCore/GDModel/enums/baseball/GameStates");

	var Superclass;

	var T = 't';

	function MatchupDataPack(game){
		var gameData = game.gameData,
			linescore = game.liveData.linescore,
			play = game.getCurrentPlay(),
			basics = game.getBasicGameStatus(),
			inningState = linescore.inningState,
			activeInning = (inningState !== "Mid" && inningState !== "End" && inningState !== "");

		if(gameData.status.abstractGamestate === "Preview") {
			this.firstPitch = gameData.datetime.firstPitchET;
		} else {
			this.firstPitch = null;
		}

		/*
		 * Mashup of data responsible for showing current pitcher
		 * batter matchup.
		 */
		this.matchup = play.matchup;
		this.count = play.count;
		this.score = {
			home : linescore.home.runs,
			away : linescore.away.runs
		};
		this.teams = {
			home : gameData.teams.home,
			away : gameData.teams.away
		};
		this.status = gameData.status.detailedStatus;
		this.inningsState = linescore.inningHalf + " " + linescore.currentInningOrdinal;
		this.showSecondLineOnInningStatus = !activeInning ||
									  gameData.datetime.resumeDate != null ||
								 	  this.firstPitch != null;

		if(exists(game, "gameData.datetime.resumeDate") && gameData.status.detailedState === GameStates.SUSPENDED) {
			var resDate = gameData.datetime.resume_date;
			this.resumeDate = resDate.substr(resDate.indexOf('/') + 1);
		} else {
			this.resumeDate = null;
		}
	}

	MatchupDataPack.prototype.mugshot = function(){
		return resourcePath.get('mugshot',{ pid : this.id});
	};

	MatchupDataPack.prototype.cssTeamID = function(){
		return this.teamID.replace('ID',T);
	}

	function MatchupDistributor(evt) {
        Superclass.constructor.call(this,evt);
		this.eventType = evt;

		MessageService.addListener.call(this, DistEvents.UPDATE_ALL, this.refresh);
		MessageService.addListener.call(this, UpdateEvents.REQUEST_MATCHUP_DATA, this.handleUpdateRequest);
	}

	ViewDistributorClass.spawn(MatchupDistributor).define({
		prepDataForView: function() {
			var game = this.game;

			this.dataPack = new MatchupDataPack(game);

			console.info("Matchup",this.dataPack);
			this.dispatchUpdates();
		}
	});

	Superclass = MatchupDistributor.superclass;

	return MatchupDistributor;
});
